export const SET_CURRENT_COMPANY_BIZMINER_RATIOS  = "SET_CURRENT_COMPANY_BIZMINER_RATIOS"
export const SET_CURRENT_COMPANY_DUPONT_RATIOS  = "SET_CURRENT_COMPANY_DUPONT_RATIOS"
export const SET_CURRENT_COMPANY_ALTMAN_Z_SCORE  = "SET_CURRENT_COMPANY_ALTMAN_Z_SCORE"